import { render } from "./ChatDetailsList.vue?vue&type=template&id=521c8624"
import script from "./ChatDetailsList.vue?vue&type=script&lang=js"
export * from "./ChatDetailsList.vue?vue&type=script&lang=js"

import "./ChatDetailsList.vue?vue&type=style&index=0&id=521c8624&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__